import {
  createContext,
  useContext,
  type SetStateAction,
  type Dispatch,
} from "react";

import type { HotelBooking } from "@/features/hotels/types/types";

export interface HotelBookingContextValue {
  data: HotelBooking | null;
  setData: Dispatch<SetStateAction<HotelBooking | null>>;
  availabilityToken: string | null;
  promoCode: string | null;
  setAvailabilityToken: (token: string | null) => void;
  setPromoCode: (code: string | null) => void;
}

export const HotelBookingContext =
  createContext<HotelBookingContextValue | null>(null);

export const useHotelBookingContext = () => {
  const context = useContext(HotelBookingContext);
  if (!context) {
    throw new Error(
      "useHotelBookingContext must be used within a HotelBookingProvider",
    );
  }
  return context;
};
